import * as React from "react"
import { Input as UIInput, type InputProps as UIInputProps } from "@tmf/ui"
import { cn } from "@/utils/cn"

/**
 * `Input` do Tennis: COMPÕE o `<Input>` do `@tmf/ui` (estrutura + size/startSlot/endSlot)
 * e aplica só a app-specific: anel de foco na cor de quadra `--court-accent`.
 */
export type InputProps = UIInputProps

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, ...props }, ref) => (
    <UIInput
      ref={ref}
      className={cn("focus-visible:ring-court-accent", className)}
      {...props}
    />
  )
)
Input.displayName = "Input"

export { Input }
